exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#displaySettingsModal .v--modal-box.v--modal{min-height:375px!important;min-width:360px!important}#displaySettingsModal .modal__footer{display:none}#displaySettingsModal .modal__content{margin-top:-65px;overflow-y:auto!important}.buttons--button{text-align:center;cursor:pointer;height:24px}.buttons__container{display:flex;flex-direction:column;justify-content:space-around;border:1px solid #d3d3d3}#displaySettingsModal .display__parameters{height:100%;align-items:center;justify-content:center}#displaySettingsModal .list--el:last-child{border-bottom:none}#displaySettingsModal .v-tabs__container{justify-content:center;margin-bottom:10px}#displaySettingsModal .settings--input{text-align:right;border-bottom:1px solid #d3d3d3}.list--el:hover{background:#e7e7e7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-429ac456","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/DisplaySettings.vue
// module id = 1820
// module chunks = 0